// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2ORsf","list":"BalanceDue_list__2ZvNh","listRow":"BalanceDue_listRow__2EQij","total":"BalanceDue_total__vc9uB"};